import moment from "moment-timezone"

import { API } from "."
import {
  ReadActivityDataListParams,
  ReadActivityDataListResponse,
  ReadSessionDataResponse,
  ReadSpeedDataResponse,
  ReadTeamDataItemsParams,
  ReadTeamDataItemsResponse,
  UpsertMatchPlayerPayload,
  UpsertMatchPlayerResponse,
} from "@/types/data"

/* 호출 시 /teams/{idfTeam} 붙음 */

/* 데이터 목록 조회 */
export async function readTeamDataItems(params: ReadTeamDataItemsParams) {
  const { startTime, endTime } = params

  return await API.get<ReadTeamDataItemsResponse>("/data", {
    params: {
      start: startTime,
      end: endTime,
    },
  })
}

/* 데이터 선수 정보 추가(데이터에 팀선수 정보를 추가) */
export async function upsertMatchPlayer(data: {
  idfData: number
  payload: UpsertMatchPlayerPayload
}) {
  const { idfData, payload } = data

  return await API.put<UpsertMatchPlayerResponse>(`/data/${idfData}/match`, payload)
}

/* 데이터 선수 정보 제거(데이터에 팀선수 정보를 제거) */
export async function deleteMatchPlayer(idfData: number) {
  return await API.delete<void>(`/data/${idfData}/unMatch`)
}

/* 데이터 그룹 조회(시간이 겹치는 데이터를 하나의 그룹으로 간주하여 집계된 그룹 목록을 응답) */
export async function readActivityDataList(params: ReadActivityDataListParams) {
  const tz = moment.tz.guess()
  params.timezone = tz

  return await API.get<ReadActivityDataListResponse>("/data/group", { params })
}

export async function readSpeedData(idfData: number) {
  return await API.get<ReadSpeedDataResponse>(`/data/${idfData}/speed`)
}

/* 세션 데이터 목록 조회(데이터와 관계되어있는 세션 데이터 목록을 조회) */
export async function readSessionData(idfData: number) {
  return await API.get<ReadSessionDataResponse>(`/data/${idfData}/sessions`)
}
